import { BrowserRouter as Router, useHistory } from 'react-router-dom';
import LoadingOverlay from 'components/common/LoadingOverlay';
import AppRouter from './AppRouter';
import AuthRouter from './AuthRouter';
import useCurrentUser from '../hooks/auth/useCurrentUser';

const WindowHistory = () => {
  const history = useHistory();
  window.currentHistory = history;
  return null;
};
const RootRouter = ({ children }) => {
  const [user, loading] = useCurrentUser();

  if (loading && !user) {
    return <LoadingOverlay />;
  }

  return (
    <Router basename={process.env.PUBLIC_URL}>
      <WindowHistory />
      {children} {user ? <AppRouter /> : <AuthRouter />}
    </Router>
  );
};

export default RootRouter;
